import { useEffect, useState } from "react";
import httpUtils from "@/utils/httpUtils";
import { env } from "@/next.config";

export const useRegion = (props) => {
  if (props === undefined) {
    props = {};
  }
  const { searchVCDropdown, searchStartupDropdown } = props;
  const [regions, setRegions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchRegions = async () => {
    setIsLoading(true);
    try {
      let params = {
        dropdown: true,
      };

      if (searchVCDropdown) {
        params = {
          searchVCDropdown: true,
        };
      }

      if (searchStartupDropdown) {
        params = {
          searchStartupDropdown: true,
        };
      }
      const response = await httpUtils.get(`${env.API_VERSION}/region`, {
        params,
      });
      setRegions(response.data);
    } catch (error) {
      console.log("Error", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (regions.length === 0) {
      fetchRegions();
    }
  }, []);

  return { regions, fetchRegions, isLoading };
};
